import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { creditsLoading : true, credits: '', creditsError: false};

export function organisationCredits(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_CREDITS:
        return {
          creditsLoading: true,
          credits: '',
          creditsError: false,
        };
      case organisationConstants.RECEIVE_CREDITS:
        return {
          creditsLoading: false,
          credits: action.orgCredits.data.organisation_credit_list,
          creditsError: false
        };
      case organisationConstants.CREDITS_ERROR:
        return { 
          creditsLoading: false,
          credits: '',
          creditsError: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/credits.reducer.js